import { useTranslation } from 'react-i18next'

import { usePublicCakeMoment, usePublicProgram } from '@/features/program/api'
import { CakeMomentSection, ProgramSection } from '@/features/program/components'

import { RubricPage } from '../components/RubricPage'

/** Le déroulé de la soirée, heure par heure, et le Cake Moment. */
export function ProgramPage() {
  const { t, i18n } = useTranslation()

  return (
    <RubricPage title={t('rubrics.program.title')} intro={t('rubrics.program.body')}>
      {(event) => (
        <ProgramPageBody slug={event.slug} timezone={event.timezone} locale={i18n.language} />
      )}
    </RubricPage>
  )
}

function ProgramPageBody({
  slug,
  timezone,
  locale,
}: {
  slug: string
  timezone: string
  locale: string
}) {
  const programQuery = usePublicProgram(slug)
  const cakeQuery = usePublicCakeMoment(slug)

  return (
    <>
      <ProgramSection items={programQuery.data ?? []} timezone={timezone} locale={locale} />
      <CakeMomentSection cake={cakeQuery.data ?? null} />
    </>
  )
}
